import { render, staticRenderFns } from "./VerAsignacionFamiliar.vue?vue&type=template&id=a040180a&scoped=true&"
import script from "./VerAsignacionFamiliar.vue?vue&type=script&lang=js&"
export * from "./VerAsignacionFamiliar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a040180a",
  null
  
)

export default component.exports